import React from 'react';
import { isEmpty } from 'lodash';

import { COLUMN_2 } from 'Components/frameworks/card/Card.constants';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { Sheet } from 'Components/frameworks/sheet/Sheet.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

export function TeaserCardsLayer({ image, title, description = '', blocks = [] }) {
  return (
    <Sheet immersive={{ url: image }}>
      {!!title && (
        <Title className="mb-8" theme="title-sans-8">
          {title}
        </Title>
      )}
      {!!description && <Text className="mb-8" text={description} />}
      {!isEmpty(blocks) && (
        <div className="flex flex-wrap -mx-2 -my-5">
          {blocks.map(({ title: blockTitle, text: blockText }, index) => {
            return blockTitle && blockText ? (
              <div className="px-2 py-5 w-full sm:w-1/2" key={index}>
                <Card
                  heading={{ hLevel: 3, title: blockTitle }}
                  layout={COLUMN_2}
                  text={{ text: blockText }}
                  theme="landing"
                />
              </div>
            ) : null;
          })}
        </div>
      )}
    </Sheet>
  );
}
